import Link from 'next/link';
import { useState } from 'react';
import HeaderNavContent from './HeaderNavContent';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Directus } from '@directus/sdk';
import Image from 'next/image';
const directus = new Directus('https://myorigin-directus.server.codegarden.co.za/', {
  mode: 'jwt',
  token: 'Bearer 8gGMoK-WT98pgKROF8Mxh5xCLwdJV2E6',
});

const DefaulHeader = () => {
  const [showForm, setShowForm] = useState(false);
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Send email to server to subscribe to notifications
    toast.success('Subscribed to notifications!');
    setShowForm(false);
    addSubscriber(email);
  };

  const addSubscriber = async (email) => {
    try {
      await directus.items('notifications').createOne({
        email: email,
      });
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <header className='main-header'>
      <div className='main-box'>
        <div className='logo-box'>
          <div className='logo'>
            <Link href='/'>
              <Image src="/origins-logo.png" alt='brand' width={100} height={50}  />
            </Link>
          </div>
        </div>
        <HeaderNavContent />
      </div>
    </header>
  );
};

export default DefaulHeader;
